import {FormInputInteger, FormMapCoordinates} from "base/component/form";

const SubaglomeracionFormLocationFields = ({orientation = "vertical"}) => {
    return <>{/*<FormMapCoordinates name="geom" orientation={orientation} />*/}</>;
};

export default SubaglomeracionFormLocationFields;
